import React from 'react';
import { Card, CardHeader } from '@material-ui/core';
import useStyles from './styles';

interface Props {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  noPadding?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export default function ({
  title,
  icon,
  children,
  noPadding,
  style,
  className,
}: Props) {
  const classes = useStyles({ noPadding });
  return (
    <Card
      component="section"
      className={[classes.root, className].join(' ').trim()}
      style={style}
    >
      <CardHeader
        component="header"
        title={title}
        titleTypographyProps={{
          component: 'h2',
          variant: 'h5',
        }}
        avatar={icon}
        className={classes.header}
      />
      {children}
    </Card>
  );
}
